import { Tag, Tooltip } from "antd"
import styled from "styled-components"

/**
 * Награды клиента глазами поддержки. Главная колонка — «Состояние»: после
 * DIG-234 на вопрос «почему не пришли баллы» есть три разных ответа, и по трём
 * булевым флагам оператор их не соберёт.
 */
const STATUS_COLORS = {
  "Начислена": "green",
  "Пользователь ещё не забрал": "orange",
  "В очереди на начисление": "blue",
}

export function getUserRewardsColumns() {
  return [
    {
      title: "Состояние",
      dataIndex: "statusText",
      key: "statusText",
      width: 200,
      render: (text, record) => (
        <>
          <StyledTag color={STATUS_COLORS[text] ?? "red"}>{text}</StyledTag>
          {record.lastError && (
            <Tooltip placement="top" title={record.lastError}>
              <ErrorHint>подробности</ErrorHint>
            </Tooltip>
          )}
        </>
      ),
    },
    {
      title: "Награда",
      dataIndex: "rewardName",
      key: "rewardName",
      render: (text, record) => (
        <>
          <div>{text}</div>
          <Muted>{record.typesText}{record.pointsCount ? ` — ${record.pointsCount} баллов` : ""}</Muted>
        </>
      ),
    },
    {
      title: "За что",
      dataIndex: "sourceTitle",
      key: "sourceTitle",
      render: (text, record) => (
        record.sourceType === "quest"
          ? <span>{text ?? "Выполнение квеста"}</span>
          : <StyledTag color="default">Достижение уровня</StyledTag>
      ),
    },
    {
      title: "Забрал",
      dataIndex: "claimedAt",
      key: "claimedAt",
      width: 150,
      render: (text, record) => {
        if (!record.needsClaim) {
          return <Muted>не требуется</Muted>
        }

        return text ? <span>{text}</span> : <StyledTag color="orange">нет</StyledTag>
      },
    },
    {
      title: "Начислена",
      dataIndex: "receivedAt",
      key: "receivedAt",
      width: 150,
      render: (text) => (text ? <span>{text}</span> : <Muted>—</Muted>),
    },
    {
      title: "Доступна с",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (text) => <Muted>{text ?? "—"}</Muted>,
    },
  ]
}

const StyledTag = styled(Tag)`
  font-weight: 600;
`

const Muted = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
`

const ErrorHint = styled.span`
  color: rgb(211, 47, 47);
  font-size: 12px;
  cursor: help;
  border-bottom: 1px dashed currentColor;
`
